export function resizedImageUrl(width, imageUrl) {
  const optionsRegex = /(=s\d+)(-c)?$/g
  let newUrl
  if (optionsRegex.test(imageUrl)) {
    newUrl = imageUrl.replace(optionsRegex, `=s${width}$2`)
  } else {
    newUrl = `${imageUrl}=s${width}`
  }
  return newUrl
}
